import { Presence } from "@liveblocks/client";
import React, { useEffect, useRef } from "react";
import useSound from "use-sound";
import { usePresence } from "../liveblocks/presences";
import { User } from "../types";
import PreviewRect from "../ui/selection/PreviewRect";

function PreviewList() {
  const [previews] = usePresence<Presence["preview"]>("preview");
  useTickSoundEffect();

  const items: [User["id"], Presence["preview"]][] = Object.entries(
    previews
  ).filter(([, preview]) => !!preview);

  return (
    <div>
      {items.map(([userId, preview]) => {
        return <PreviewRect key={userId} preview={preview} userId={userId} />;
      })}
    </div>
  );
}

function useTickSoundEffect() {
  const [playTick] = useSound("/assets/sounds/tick.wav", {
    volume: 0.05,
  });
  const [playTock] = useSound("/assets/sounds/tock.wav", { volume: 0.05 });

  const [previews] = usePresence<Presence["preview"]>("preview");
  const count = Object.values(previews).filter((p) => !!p);
  const prevCount = useRef(count);

  useEffect(() => {
    if (count > prevCount.current) {
      playTick();
    }
    if (count < prevCount.current) {
      playTock();
    }
    prevCount.current = count;
  }, [count, playTick, playTock, prevCount]);
}

export default React.memo(PreviewList);
